<script setup>
  import {computed, useSlots} from "vue";

  defineOptions({
    name: "DashboardWidget",
  });

  const slots = useSlots();

  defineProps({
    title: {
      type: String,
      default: null,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
  });

  const hasActionsSlot = computed(() => !!slots.actions);
  const hasTitleSlot = computed(() => !!slots.title);
</script>

<template>
  <div class="flex flex-col rounded-lg border-1 bg-white shadow-md" :data-test="getTestId('widget')">
    <h3 v-if="title || hasTitleSlot" class="px-4 pt-4 text-2xl font-semibold">
      <slot name="title" />
      {{ title }}
    </h3>

    <div class="flex-1 p-4">
      <slot name="default" />
    </div>

    <div v-if="hasActionsSlot && !hideActions" class="flex flex-row-reverse space-x-2 space-x-reverse px-4 pb-4">
      <slot name="actions" />
    </div>
  </div>
</template>
